import { render, staticRenderFns } from "./button-favorite.vue?vue&type=template&id=f8d5d3f0&"
import script from "./button-favorite.vue?vue&type=script&lang=js&"
export * from "./button-favorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports